import { Link, useNavigate } from 'react-router-dom';
import { ChatIcon } from '@/components/layout/icons';
import { NotificationsBell } from '@/components/layout/notifications-bell';
import { UserMenu } from '@/components/layout/user-menu';
import { fullName } from '@/lib/format';
import { useMe } from '@shared/hooks/use-me';
import { useAuthStore } from '@shared/stores/auth-store';
import { getTokenStore } from '@shared/api/token-store';
import { logout } from '@shared/api/auth';

export interface AssociateTopbarProps {
  onMenuClick: () => void;
}

export function AssociateTopbar({ onMenuClick }: AssociateTopbarProps) {
  const { data: me } = useMe();
  const signOut = useAuthStore((s) => s.signOut);
  const navigate = useNavigate();

  async function onSignOut() {
    try {
      await logout();
    } catch {
      /* ignore */
    }
    getTokenStore().clear('associate');
    signOut();
    navigate('/associate/login', { replace: true });
  }

  return (
    <header className="sticky top-0 z-10 border-b border-gray-200 bg-white">
      <div className="flex items-center justify-between gap-2 px-4 py-2.5 sm:gap-4 sm:px-6 sm:py-3">
        <div className="flex items-center gap-2">
          <button
            onClick={onMenuClick}
            className="rounded-md p-1.5 text-gray-500 hover:bg-gray-100 md:hidden"
            aria-label="Open menu"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>

          <Link
            to="/associate/transactions"
            className="flex shrink-0 items-center gap-1.5 md:hidden"
          >
            <img src="/ecregi_logo.png" alt="EcRegi" className="h-6 w-6" />
            <span className="text-sm font-semibold text-brand-700">ECREGI</span>
          </Link>
        </div>

        <div className="ml-auto flex shrink-0 items-center gap-1 sm:gap-2">
          <Link
            to="/associate/chat"
            className="rounded-full p-2 text-gray-600 hover:bg-gray-100"
            aria-label="Chat"
          >
            <ChatIcon />
          </Link>
          <NotificationsBell />
          <UserMenu
            name={me ? fullName(me.firstName, me.lastName) : ''}
            email={me?.email ?? ''}
            avatarUrl={me?.avatarUrl ?? undefined}
            profileHref="/associate/profile"
            onSignOut={onSignOut}
          />
        </div>
      </div>
    </header>
  );
}
